module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** SitePage Dvd1 Free Tour */

/* (function(fox) {
	fox.registerWidget('SitePage_Account', {
		configure: function(options) {
			this.prepareOptions(options, {
				
			});
			this.callParent('configure', arguments);
		},
	}, 'Site_Page');

})(fox); */

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/account.js
// module id = 1274
// module chunks = 4